import { useQuery } from '@tanstack/react-query';
import { map, mapValues, keyBy } from 'lodash';
import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestSimplifiedDataArray } from 'src/types/requestData';
import { getRequest } from 'src/utils/request';

const excludeFields = ['User ID', 'Cancellation ID', 'Job ID', 'Project ID'];

const mapCancellationFilters = (
  data: {
    id: string;
    type: string;
    attributes: UCM.DynamicFiltersAttributesRawType;
  }[],
) => {
  const filteredData = data.filter(
    (filter) => !excludeFields.includes(filter.attributes.field_name),
  );
  const fields = map(filteredData, (filter) => ({
    label: filter.attributes.field_name,
    value: filter.attributes.field_name,
  }));
  const types = mapValues(keyBy(data, 'attributes.field_name'), (filter) =>
    filter.attributes.field_type?.toLowerCase(),
  );
  const operators = mapValues(keyBy(data, 'attributes.field_name'), (filter) =>
    map(filter.attributes.operators, (operator) => ({
      label: operator.label,
      value: operator.code,
    })),
  );
  const options = mapValues(
    keyBy(data, 'attributes.field_name'),
    (filter) => filter.attributes.options,
  );
  return { fields, types, operators, options };
};

const getCancellationFilters = async () => {
  const {
    data: { data },
  } = await getRequest<RequestSimplifiedDataArray<UCM.DynamicFiltersRawType>>(
    API.GET.cancellationFilters,
  );

  return mapCancellationFilters(data);
};

export const useGetCancellationFilters = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CANCELLATION_FILTERS],
    queryFn: () => getCancellationFilters(),
    staleTime: 1000 * 60 * 30,
    ...config,
  });
};
